"use client";

import WebLayout from "@/components/layout/web/WebLayout";
import CPageHeaderSkeleton from "@/components/main/CPageHeaderSkeleton";
import { Card, Skeleton } from "@mantine/core";

const loading = () => {
  return (
    <>
      <CPageHeaderSkeleton />
      <div className="flex flex-col items-center">
        <div className="max-w-[800px] mx-auto my-8 w-full px-5">
          <Skeleton height={35} width={166} className="mx-auto mb-4" />
          <Skeleton height={20} my={3} className="max-w-[800px]" />
          <Skeleton height={20} my={3} className="max-w-[800px]" />
          <Skeleton height={20} my={3} className="max-w-[800px]" />
          <Skeleton height={20} my={3} className="max-w-[800px]" />
        </div>
        <div className="md:flex mx-3 md:space-x-3 max-w-[800px] mb-10 w-full px-5">
          <Card withBorder padding={"xl"} radius={"lg"} className="w-full mt-3">
            <Skeleton height={30} width={30} className="rounded-full" />
            <Skeleton height={24} width={200} className="m-0 my-3" />
            <Skeleton height={99} className="max-w-[324px] m-0 my-3" />
            <Skeleton height={30} width={100} className="m-0 my-3" />
          </Card>
          <Card withBorder padding={"xl"} radius={"lg"} className="w-full mt-3">
            <Skeleton height={30} width={30} className="rounded-full" />
            <Skeleton height={24} width={200} className="m-0 my-3" />
            <Skeleton height={99} className="max-w-[324px] m-0 my-3" />
            <Skeleton height={30} width={100} className="m-0 my-3" />
          </Card>
        </div>
      </div>
    </>
  );
};

export default WebLayout(loading);
